<div class="user-picker-field">
    <!-- Inside a dialog the header already names the field, so the label is left off. -->
    @if (label) {
        <div class="label-container">
            <cerrix-label [for]="name">{{ label }}</cerrix-label>
            @if (infoText) {
                <cerrix-instructions-icon
                    class="input-instructions-icon"
                    [instructionText]="infoText"
                    [showText]="false"
                ></cerrix-instructions-icon>
            }
        </div>
    }
    <app-cerrix-tabs
        validationErrors
        [attr.name]="name"
    >
        @if (!readonly) {
            <ng-template appCerrixTab [label]="'colleaguesTabLabel' | t">
                <div class="toolbar">
                    <cerrix-search-input
                        [placeholder]="'searchPlaceholder' | t"
                        [(value)]="filter"
                    ></cerrix-search-input>
                </div>
                <app-cerrix-select-list
                    [options]="filteredUserList()"
                    [selectedValues]="selectedValues"
                    [multiselect]="multiselect"
                    (selectedValuesChange)="setSelectedUsers($event)"
                ></app-cerrix-select-list>
            </ng-template>
        }
        <ng-template appCerrixTab [label]="'selectedTabLabel' | t">
            <app-cerrix-select-list
                [options]="selectedUserList()"
                [selectedValues]="selectedValues"
                [multiselect]="multiselect"
                (selectedValuesChange)="setSelectedUsers($event)"
                [readonly]="readonly"
            ></app-cerrix-select-list>
        </ng-template>
    </app-cerrix-tabs>
</div>
